import { gql } from '@apollo/client';

/**
 * Update company's get-started state (triggered/completed).
 * Called when user triggers or dismisses the checklist widget.
 * Uses updateCompanyInfo with getStarted field — there is no dedicated
 * updateGetStarted resolver in the backend.
 */
export const UPDATE_GET_STARTED = gql`
  mutation UpdateGetStarted($updateData: UpdateCompanySettingInput!) {
    updateCompanyInfo(updateData: $updateData) {
      _id
      getStarted {
        triggered
        completed
        completedDate
      }
    }
  }
`;

/**
 * Trigger the firstContentCreated flag when user creates their first asset.
 * This fires once per company lifetime.
 */
export const TRIGGER_FIRST_CONTENT_CREATED = gql`
  mutation TriggerFirstContentCreated {
    triggerFirstContentCreated
  }
`;

/**
 * Mark `company.payment.trialStartEventFired = 'TRIGGERED'` so the
 * trialCreated analytics event only fires once per account. Mirrors scio1
 * `Meteor.call('triggerTrialStartEvent', company._id)` invoked from
 * `dashboard.js:170` right after `trackingTrialCreated()` fires.
 */
export const TRIGGER_TRIAL_START_EVENT = gql`
  mutation TriggerTrialStartEvent {
    triggerTrialStartEvent
  }
`;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface UpdateGetStartedResponse {
  updateCompanyInfo: {
    _id: string;
    getStarted?: {
      triggered: boolean;
      completed: boolean;
      completedDate?: string | null;
    } | null;
  };
}

export interface TriggerFirstContentCreatedResponse {
  triggerFirstContentCreated: boolean;
}

export interface TriggerTrialStartEventResponse {
  triggerTrialStartEvent: boolean;
}
